/** Terms of Service page copy — PT-BR */
export const termsPt = {
  kicker: 'Documentos oficiais · Rede Nexus',
  title: 'Termos de Serviço',
  lead:
    'Regras e privacidade da Rede Nexus, operada pela Vih\'s Studio — aplicáveis ao site e aos servidores da rede, incluindo o Nexus Origins.',
  updated: 'Última atualização: 23 de julho de 2026',
  tocLabel: 'Índice',
  tocAria: 'Índice dos termos',
  ctaTitle: 'Dúvidas sobre os termos?',
  ctaLead:
    'Fale com a staff no Discord oficial da Rede Nexus — esclarecemos qualquer ponto.',
  ctaDiscord: 'Falar no Discord',
  backHome: 'Voltar ao início',
  footerBrand:
    'Rede de servidores Minecraft pela Vih\'s Studio. Atualmente: Nexus Origins — vanilla com plugins oficiais, economia, clãs e eventos.',
  privacyLink: 'Privacidade',
  sections: [
    {
      id: 'aceitacao',
      number: '01',
      title: 'Aceitação dos Termos',
      blocks: [
        {
          type: 'p',
          text:
            'Estes Termos de Serviço (“Termos”) regem o acesso e o uso do site, das plataformas digitais e dos servidores de jogos operados sob a marca **Rede Nexus**, mantida por **Vih\'s Studio** (“nós”, “nosso” ou “Vih\'s Studio”).',
        },
        {
          type: 'p',
          text:
            'Ao acessar o site da Rede Nexus, criar conta, entrar em qualquer servidor da rede (incluindo, mas não se limitando ao **Nexus Origins**), utilizar canais oficiais de comunicação (como Discord) ou realizar doações e contribuições, você declara ter lido, compreendido e concordado com estes Termos e com a Política de Privacidade aqui incorporada.',
        },
        {
          type: 'p',
          text:
            'Se você não concordar com qualquer disposição destes Termos, não deverá utilizar nossos serviços.',
        },
      ],
    },
    {
      id: 'definicoes',
      number: '02',
      title: 'Definições e Escopo',
      blocks: [
        { type: 'p', text: 'Para fins destes Termos:' },
        {
          type: 'ul',
          items: [
            '**Vih\'s Studio** — marca central responsável pela operação, gestão e desenvolvimento da Rede Nexus.',
            '**Rede Nexus** — ecossistema de servidores Minecraft, site institucional, sistemas de conta, loja, Discord e demais serviços digitais vinculados à marca Nexus.',
            '**Nexus Origins** — servidor Minecraft atualmente ativo na Rede Nexus, baseado em experiência vanilla aprimorada exclusivamente por plugins desenvolvidos pelos times da Rede Nexus / Vih\'s Studio.',
            '**Usuário / Jogador** — qualquer pessoa que acesse o site ou utilize os serviços da Rede Nexus.',
            '**Serviços** — site, servidores de jogo, Discord, sistemas de autenticação, economia, clãs, eventos, planos VIP, doações e demais funcionalidades oferecidas.',
          ],
        },
        {
          type: 'p',
          text:
            'Este site pertence à Rede Nexus e poderá, no futuro, abranger outros servidores além do Nexus Origins. Salvo indicação em contrário, estes Termos aplicam-se a todos os serviços atuais e futuros operados sob a Rede Nexus.',
        },
      ],
    },
    {
      id: 'servicos',
      number: '03',
      title: 'Descrição dos Serviços',
      blocks: [
        {
          type: 'p',
          text:
            '3.1. A Rede Nexus oferece ambientes de jogo Minecraft, conteúdo comunitário e ferramentas digitais relacionadas, sob responsabilidade da Vih\'s Studio.',
        },
        {
          type: 'p',
          text:
            '3.2. O **Nexus Origins** utiliza apenas plugins oficiais desenvolvidos pelos desenvolvedores da Rede Nexus / Vih\'s Studio. Não se trata de servidor de modpack.',
        },
        {
          type: 'p',
          text:
            '3.3. Projetos anteriores da marca (como o antigo **Nexus SMP**, baseado em modpack) não refletem necessariamente a arquitetura, as regras ou a proposta atual do Nexus Origins. Em caso de conflito entre informações históricas e estes Termos, prevalece o disposto neste documento.',
        },
        {
          type: 'p',
          text:
            '3.4. Podemos alterar, suspender, expandir ou descontinuar funcionalidades, eventos, servidores ou canais a qualquer momento, visando manutenção, segurança, evolução técnica ou interesse operacional da rede.',
        },
        {
          type: 'p',
          text:
            '3.5. Minecraft é um jogo de propriedade da Mojang Studios / Microsoft. A Rede Nexus e a Vih\'s Studio não são afiliadas, endossadas ou patrocinadas pela Mojang Studios ou pela Microsoft.',
        },
      ],
    },
    {
      id: 'elegibilidade',
      number: '04',
      title: 'Elegibilidade e Idade Mínima',
      blocks: [
        {
          type: 'p',
          text:
            '4.1. Os serviços da Rede Nexus destinam-se a usuários com **13 anos ou mais**.',
        },
        {
          type: 'p',
          text:
            '4.2. Menores de 18 anos devem utilizar os serviços somente com autorização e supervisão de pais ou responsáveis legais, que respondem pelo uso realizado pelo menor.',
        },
        {
          type: 'p',
          text:
            '4.3. Ao utilizar os serviços, você declara ter capacidade legal para aceitar estes Termos ou, se menor, contar com consentimento válido do responsável.',
        },
      ],
    },
    {
      id: 'conta',
      number: '05',
      title: 'Conta do Usuário',
      blocks: [
        {
          type: 'p',
          text:
            '5.1. Você é responsável por manter a segurança de sua conta Minecraft, de credenciais vinculadas ao site da Rede Nexus e de quaisquer meios de autenticação utilizados.',
        },
        {
          type: 'p',
          text:
            '5.2. É proibido compartilhar, vender, alugar ou transferir contas, senhas ou acesso a terceiros.',
        },
        {
          type: 'p',
          text:
            '5.3. A equipe da Rede Nexus / Vih\'s Studio **nunca** solicitará sua senha por mensagem privada, Discord, e-mail ou qualquer outro canal.',
        },
        {
          type: 'p',
          text:
            '5.4. Você é responsável por toda atividade realizada sob suas contas. Notifique a administração imediatamente em caso de suspeita de acesso não autorizado.',
        },
        {
          type: 'p',
          text:
            '5.5. Reservamo-nos o direito de suspender ou encerrar contas que violem estes Termos, que apresentem risco à segurança da rede ou que sejam utilizadas de forma fraudulenta.',
        },
      ],
    },
    {
      id: 'software',
      number: '06',
      title: 'Software, Plugins, Clientes e Modpacks',
      blocks: [
        {
          type: 'p',
          text:
            '6.1. No **Nexus Origins**, a experiência de jogo é construída com plugins oficiais da Rede Nexus. O uso de modpacks, mods de conteúdo ou clientes modificados que alterem a jogabilidade de forma não autorizada não faz parte da proposta atual deste servidor.',
        },
        {
          type: 'p',
          text:
            '6.2. É estritamente proibido utilizar hacks, cheats, injectors, x-ray, auto-clickers, macros abusivos, clients com vantagens injustas, exploits ou qualquer software que confira benefício indevido sobre outros jogadores.',
        },
        {
          type: 'p',
          text:
            '6.3. Mods puramente cosméticos ou de qualidade de vida (quando expressamente permitidos pela administração) não devem conceder vantagem competitiva. Em caso de dúvida, consulte a staff antes de utilizar.',
        },
        {
          type: 'p',
          text:
            '6.4. Plugins, sistemas, scripts, APIs, integrações e conteúdos digitais desenvolvidos pela Rede Nexus / Vih\'s Studio são protegidos por direitos de propriedade intelectual. É vedada a engenharia reversa, cópia, redistribuição ou exploração comercial sem autorização prévia e por escrito.',
        },
        {
          type: 'p',
          text:
            '6.5. Tentativas de comprometer a infraestrutura (DDoS, scanning abusivo, exploração de vulnerabilidades, bypass de autenticação, etc.) resultarão em banimento e poderão ser comunicadas às autoridades competentes.',
        },
      ],
    },
    {
      id: 'conduta',
      number: '07',
      title: 'Conduta do Jogador',
      blocks: [
        {
          type: 'p',
          text:
            '7.1. Todos os usuários devem tratar jogadores, staff e a comunidade com respeito.',
        },
        {
          type: 'p',
          text:
            '7.2. São proibidos discursos de ódio, discriminação, assédio, bullying, ameaças, doxxing, conteúdo sexual envolvendo menores, pornografia, apologia a crimes e qualquer conteúdo ilegal ou ofensivo.',
        },
        {
          type: 'p',
          text:
            '7.3. Spam, flood, propaganda não autorizada, scam, phishing e divulgação de links maliciosos são proibidos em jogo, no Discord e em demais canais oficiais.',
        },
        {
          type: 'p',
          text:
            '7.4. É vedado o uso de nomes, skins, builds, mensagens ou símbolos que violem a lei, direitos de terceiros ou as diretrizes da comunidade.',
        },
        {
          type: 'p',
          text:
            '7.5. Regras específicas de cada servidor da Rede Nexus (quando publicadas) complementam estes Termos e devem ser observadas.',
        },
      ],
    },
    {
      id: 'conteudo',
      number: '08',
      title: 'Conteúdo do Usuário e Propriedade Intelectual',
      blocks: [
        {
          type: 'p',
          text:
            '8.1. Você mantém os direitos sobre criações originais que produzir no servidor (construções, textos, imagens etc.), mas concede à Rede Nexus / Vih\'s Studio licença não exclusiva, gratuita e mundial para exibir, gravar, promover e utilizar esse conteúdo em materiais oficiais da comunidade (streamings, redes sociais, site, trailers), sem obrigação de remuneração adicional.',
        },
        {
          type: 'p',
          text:
            '8.2. Marcas, logotipos, identidade visual, nome “Nexus”, “Nexus Origins”, “Rede Nexus”, “Vih\'s Studio”, plugins, código e materiais oficiais são de titularidade da Vih\'s Studio ou de seus licenciadores.',
        },
        {
          type: 'p',
          text:
            '8.3. É proibido utilizar as marcas da Rede Nexus de forma que sugira afiliação, parceria ou endosso sem autorização expressa.',
        },
      ],
    },
    {
      id: 'punicoes',
      number: '09',
      title: 'Moderação e Punições',
      blocks: [
        {
          type: 'p',
          text:
            '9.1. A equipe de moderação reserva-se o direito de aplicar medidas disciplinares a usuários que violem estes Termos, regras do servidor ou diretrizes da comunidade.',
        },
        {
          type: 'p',
          text:
            '9.2. As punições podem incluir avisos, mutes, kicks, remoção de itens/progresso obtido de forma irregular, suspensões temporárias ou banimentos permanentes, conforme a gravidade e reincidência.',
        },
        {
          type: 'p',
          text:
            '9.3. Decisões de moderação são, em regra, finais. Contestações de boa-fé podem ser apresentadas pelos canais oficiais indicados pela administração, sem garantia de revisão ou reembolso.',
        },
        {
          type: 'p',
          text:
            '9.4. A ausência de punição imediata não implica renúncia ao direito de aplicar sanções posteriormente.',
        },
      ],
    },
    {
      id: 'doacoes',
      number: '10',
      title: 'Doações, VIP e Contribuições Financeiras',
      blocks: [
        {
          type: 'p',
          text:
            '10.1. Doações e contribuições financeiras realizadas à Rede Nexus / Vih\'s Studio (incluindo via PIX ou outros meios disponibilizados) são, em regra, **voluntárias e não reembolsáveis**, observadas as hipóteses legais cabíveis no Código de Defesa do Consumidor (Lei nº 8.078/90) e demais normas aplicáveis.',
        },
        {
          type: 'p',
          text:
            '10.2. Ao realizar uma doação ou aquisição de benefício (como planos VIP), o usuário declara estar ciente de que:',
        },
        {
          type: 'ul',
          items: [
            'Doações espontâneas sem contraprestação não garantem vantagens no jogo, salvo quando expressamente descritas em campanhas ou produtos oficiais.',
            'Valores arrecadados destinam-se prioritariamente a custear hospedagem, infraestrutura, desenvolvimento, moderação e melhorias da Rede Nexus.',
            'Benefícios VIP ou recompensas simbólicas, quando oferecidos, são virtuais, não transferíveis (salvo regra expressa em contrário) e não possuem valor monetário resgatável fora da plataforma.',
          ],
        },
        {
          type: 'p',
          text:
            '10.3. Nos termos da legislação tributária brasileira (Lei nº 5.172/66 — Código Tributário Nacional), doações voluntárias sem contraprestação não se confundem, por si só, com operação mercantis típicas de compra e venda de mercadorias.',
        },
        {
          type: 'p',
          text:
            '10.4. Dados fornecidos no processo de pagamento ou doação serão tratados conforme a LGPD (Lei nº 13.709/18), para registro, suporte, prevenção a fraudes e cumprimento de obrigações legais.',
        },
        {
          type: 'p',
          text:
            '10.5. Benefícios concedidos como agradecimento ou produto digital não configuram vínculo empregatício, sociedade, representação ou qualquer outra relação jurídica além da prevista nestes Termos.',
        },
        {
          type: 'p',
          text:
            '10.6. Em caso de encerramento de um servidor específico ou da Rede Nexus, valores já aplicados em custos operacionais não serão devolvidos. Benefícios digitais ativos poderão ser encerrados sem direito a indenização, ressalvadas obrigações legais inafastáveis.',
        },
        {
          type: 'p',
          text:
            '10.7. Tentativas de chargeback indevido, fraude de pagamento ou abuso de sistemas de doação/VIP poderão resultar em banimento e cobrança das medidas cabíveis.',
        },
      ],
    },
    {
      id: 'disponibilidade',
      number: '11',
      title: 'Disponibilidade e Manutenção',
      blocks: [
        {
          type: 'p',
          text:
            '11.1. Empenhamo-nos em manter os serviços estáveis, porém não garantimos disponibilidade ininterrupta, livre de erros ou compatível com todos os dispositivos e conexões.',
        },
        {
          type: 'p',
          text:
            '11.2. Podem ocorrer manutenções programadas ou emergenciais, reinícios, rollbacks, perda parcial de progresso e interrupções decorrentes de falhas de terceiros (hospedagem, internet, Discord, gateways de pagamento, etc.).',
        },
        {
          type: 'p',
          text:
            '11.3. Recomendamos que jogadores não baseiem expectativas críticas exclusivamente na continuidade permanente de qualquer mundo, item ou funcionalidade.',
        },
      ],
    },
    {
      id: 'isencao',
      number: '12',
      title: 'Isenção e Limitação de Responsabilidade',
      blocks: [
        {
          type: 'p',
          text:
            '12.1. Na máxima extensão permitida pela legislação brasileira, a Rede Nexus e a Vih\'s Studio não se responsabilizam por danos indiretos, lucros cessantes, perda de dados, itens virtuais, tempo de jogo ou oportunidades decorrentes do uso ou da impossibilidade de uso dos serviços.',
        },
        {
          type: 'p',
          text:
            '12.2. Não nos responsabilizamos por condutas de outros jogadores, conteúdos de terceiros, links externos ou serviços de plataformas parceiras fora do nosso controle direto.',
        },
        {
          type: 'p',
          text:
            '12.3. Nada nestes Termos exclui direitos do consumidor que não possam ser afastados por acordo, nos termos da legislação aplicável.',
        },
      ],
    },
    {
      id: 'privacidade',
      number: '13',
      title: 'Política de Privacidade (LGPD)',
      blocks: [
        {
          type: 'p',
          text:
            'Esta seção constitui a Política de Privacidade da Rede Nexus / Vih\'s Studio e descreve como tratamos dados pessoais em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/18).',
        },
        { type: 'h', text: '13.1. Controlador' },
        {
          type: 'p',
          text:
            'O tratamento de dados pessoais no âmbito da Rede Nexus é realizado sob responsabilidade da Vih\'s Studio, por meio dos canais oficiais de contato indicados neste documento.',
        },
        { type: 'h', text: '13.2. Dados que podemos coletar' },
        {
          type: 'ul',
          items: [
            'Identificadores de jogo (nickname Minecraft, UUID) e dados de conta no site.',
            'Dados de contato fornecidos voluntariamente (e-mail, Discord ID/username).',
            'Dados técnicos de conexão e segurança (endereço IP, logs de acesso, horários, informações de dispositivo/navegador, quando aplicável).',
            'Registros de moderação, tickets de suporte e interações em canais oficiais.',
            'Dados de pagamento/doação necessários ao processamento da transação (tratados, em parte, por processadores de pagamento terceiros).',
          ],
        },
        { type: 'h', text: '13.3. Finalidades do tratamento' },
        {
          type: 'ul',
          items: [
            'Prestar, operar, proteger e melhorar os serviços da Rede Nexus.',
            'Autenticar usuários, prevenir fraudes, abusos e incidentes de segurança.',
            'Aplicar regras de comunidade e decisões de moderação.',
            'Processar doações, benefícios VIP e suporte ao usuário.',
            'Cumprir obrigações legais e responder a autoridades competentes quando exigido.',
            'Comunicar atualizações relevantes sobre os serviços, quando necessário.',
          ],
        },
        { type: 'h', text: '13.4. Bases legais' },
        {
          type: 'p',
          text:
            'Tratamos dados com fundamento em execução de contrato/procedimentos preliminares, legítimo interesse (segurança e operação da comunidade), cumprimento de obrigação legal e/ou consentimento, conforme o caso concreto.',
        },
        { type: 'h', text: '13.5. Compartilhamento' },
        {
          type: 'p',
          text:
            'Não vendemos dados pessoais. Podemos compartilhar informações com prestadores essenciais (hospedagem, analytics sob controle, gateways de pagamento, plataformas de comunicação) e com autoridades quando houver obrigação legal. Exigimos de fornecedores o tratamento adequado à finalidade contratada.',
        },
        { type: 'h', text: '13.6. Cookies e tecnologias similares' },
        {
          type: 'p',
          text:
            'O site pode utilizar cookies e tecnologias equivalentes para autenticação, preferências, segurança e análise de uso. Você pode gerenciar cookies nas configurações do navegador, ciente de que certas funções podem ser afetadas.',
        },
        { type: 'h', text: '13.7. Retenção' },
        {
          type: 'p',
          text:
            'Mantemos dados pelo tempo necessário às finalidades descritas, para exercício regular de direitos e cumprimento de obrigações legais. Logs de segurança e moderação podem ser retidos por períodos compatíveis com prevenção a abusos e reincidência.',
        },
        { type: 'h', text: '13.8. Segurança' },
        {
          type: 'p',
          text:
            'Adotamos medidas técnicas e administrativas razoáveis para proteger dados pessoais. Nenhum sistema é absolutamente seguro; incentivamos boas práticas de proteção de conta por parte dos usuários.',
        },
        { type: 'h', text: '13.9. Direitos do titular' },
        {
          type: 'p',
          text:
            'Nos termos da LGPD, você pode solicitar confirmação de tratamento, acesso, correção, anonimização, portabilidade (quando aplicável), eliminação de dados desnecessários, informação sobre compartilhamentos e revogação de consentimento. Pedidos podem ser feitos pelos canais oficiais (Discord da Rede Nexus). Poderemos solicitar verificação de identidade antes de atender.',
        },
        { type: 'h', text: '13.10. Menores' },
        {
          type: 'p',
          text:
            'Não coletamos intencionalmente dados de crianças abaixo da idade mínima permitida sem bases adequadas. Responsáveis que identifiquem cadastro irregular devem contatar a administração para as providências cabíveis.',
        },
      ],
    },
    {
      id: 'alteracoes',
      number: '14',
      title: 'Alterações destes Termos',
      blocks: [
        {
          type: 'p',
          text:
            '14.1. Podemos atualizar estes Termos e a Política de Privacidade periodicamente para refletir mudanças legais, técnicas ou operacionais da Rede Nexus.',
        },
        {
          type: 'p',
          text:
            '14.2. A versão vigente será publicada nesta página, com indicação da data da última atualização. Alterações relevantes poderão ser comunicadas pelos canais oficiais.',
        },
        {
          type: 'p',
          text:
            '14.3. O uso contínuo dos serviços após a publicação das alterações constitui aceitação da nova versão, salvo quando a lei exigir consentimento específico.',
        },
        {
          type: 'note',
          text:
            '**Observação:** Estes Termos foram atualizados em 23/07/2026 para refletir a identidade da **Rede Nexus**, o servidor ativo **Nexus Origins** (plugins oficiais da Vih\'s Studio), o escopo multi-servidor do site e o reforço da Política de Privacidade à luz da LGPD e demais normas brasileiras aplicáveis.',
        },
      ],
    },
    {
      id: 'lei',
      number: '15',
      title: 'Lei Aplicável e Contato',
      blocks: [
        {
          type: 'p',
          text:
            '15.1. Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca do domicílio do usuário consumidor, quando aplicável o Código de Defesa do Consumidor, ou outro foro legalmente competente.',
        },
        {
          type: 'p',
          text:
            '15.2. Se qualquer cláusula for considerada inválida, as demais permanecerão em pleno vigor.',
        },
        {
          type: 'p',
          text:
            '15.3. Dúvidas sobre estes Termos, sobre a Política de Privacidade ou sobre o exercício de direitos de titular de dados devem ser encaminhadas preferencialmente pelo Discord oficial da Rede Nexus.',
        },
      ],
    },
  ],
};

/** Terms of Service page copy — EN */
export const termsEn = {
  kicker: 'Official documents · Nexus Network',
  title: 'Terms of Service',
  lead:
    'Rules and privacy for the Nexus Network, operated by Vih\'s Studio — applicable to the website and network servers, including Nexus Origins.',
  updated: 'Last updated: July 23, 2026',
  tocLabel: 'Contents',
  tocAria: 'Terms table of contents',
  ctaTitle: 'Questions about the terms?',
  ctaLead:
    'Reach the staff on the official Nexus Network Discord — we\'ll clarify any point.',
  ctaDiscord: 'Chat on Discord',
  backHome: 'Back to home',
  footerBrand:
    'Minecraft server network by Vih\'s Studio. Currently: Nexus Origins — vanilla with official plugins, economy, clans, and events.',
  privacyLink: 'Privacy',
  sections: [
    {
      id: 'aceitacao',
      number: '01',
      title: 'Acceptance of the Terms',
      blocks: [
        {
          type: 'p',
          text:
            'These Terms of Service (“Terms”) govern access to and use of the website, digital platforms, and game servers operated under the **Nexus Network** brand, maintained by **Vih\'s Studio** (“we”, “our”, or “Vih\'s Studio”).',
        },
        {
          type: 'p',
          text:
            'By accessing the Nexus Network website, creating an account, joining any network server (including, but not limited to, **Nexus Origins**), using official communication channels (such as Discord), or making donations and contributions, you acknowledge that you have read, understood, and agreed to these Terms and to the Privacy Policy incorporated herein.',
        },
        {
          type: 'p',
          text:
            'If you do not agree with any provision of these Terms, you must not use our services.',
        },
      ],
    },
    {
      id: 'definicoes',
      number: '02',
      title: 'Definitions and Scope',
      blocks: [
        { type: 'p', text: 'For the purposes of these Terms:' },
        {
          type: 'ul',
          items: [
            '**Vih\'s Studio** — the central brand responsible for operating, managing, and developing the Nexus Network.',
            '**Nexus Network** — the ecosystem of Minecraft servers, institutional website, account systems, store, Discord, and other digital services linked to the Nexus brand.',
            '**Nexus Origins** — the Minecraft server currently active on the Nexus Network, based on a vanilla experience enhanced exclusively by plugins developed by the Nexus Network / Vih\'s Studio teams.',
            '**User / Player** — any person who accesses the website or uses Nexus Network services.',
            '**Services** — the website, game servers, Discord, authentication systems, economy, clans, events, VIP plans, donations, and other features offered.',
          ],
        },
        {
          type: 'p',
          text:
            'This website belongs to the Nexus Network and may, in the future, cover servers beyond Nexus Origins. Unless otherwise indicated, these Terms apply to all current and future services operated under the Nexus Network.',
        },
      ],
    },
    {
      id: 'servicos',
      number: '03',
      title: 'Description of Services',
      blocks: [
        {
          type: 'p',
          text:
            '3.1. The Nexus Network provides Minecraft game environments, community content, and related digital tools, under the responsibility of Vih\'s Studio.',
        },
        {
          type: 'p',
          text:
            '3.2. **Nexus Origins** uses only official plugins developed by Nexus Network / Vih\'s Studio developers. It is not a modpack server.',
        },
        {
          type: 'p',
          text:
            '3.3. Previous projects under the brand (such as the former **Nexus SMP**, based on a modpack) do not necessarily reflect the architecture, rules, or current proposal of Nexus Origins. In the event of a conflict between historical information and these Terms, this document prevails.',
        },
        {
          type: 'p',
          text:
            '3.4. We may change, suspend, expand, or discontinue features, events, servers, or channels at any time for maintenance, security, technical evolution, or the network\'s operational interests.',
        },
        {
          type: 'p',
          text:
            '3.5. Minecraft is a game owned by Mojang Studios / Microsoft. The Nexus Network and Vih\'s Studio are not affiliated with, endorsed by, or sponsored by Mojang Studios or Microsoft.',
        },
      ],
    },
    {
      id: 'elegibilidade',
      number: '04',
      title: 'Eligibility and Minimum Age',
      blocks: [
        {
          type: 'p',
          text:
            '4.1. Nexus Network services are intended for users who are **13 years of age or older**.',
        },
        {
          type: 'p',
          text:
            '4.2. Users under 18 may use the services only with authorization and supervision from a parent or legal guardian, who is responsible for the minor\'s use.',
        },
        {
          type: 'p',
          text:
            '4.3. By using the services, you represent that you have legal capacity to accept these Terms or, if a minor, that you have valid consent from a guardian.',
        },
      ],
    },
    {
      id: 'conta',
      number: '05',
      title: 'User Account',
      blocks: [
        {
          type: 'p',
          text:
            '5.1. You are responsible for keeping your Minecraft account, credentials linked to the Nexus Network website, and any authentication methods you use secure.',
        },
        {
          type: 'p',
          text:
            '5.2. Sharing, selling, renting, or transferring accounts, passwords, or access to third parties is prohibited.',
        },
        {
          type: 'p',
          text:
            '5.3. The Nexus Network / Vih\'s Studio team will **never** ask for your password via private message, Discord, email, or any other channel.',
        },
        {
          type: 'p',
          text:
            '5.4. You are responsible for all activity under your accounts. Notify the administration immediately if you suspect unauthorized access.',
        },
        {
          type: 'p',
          text:
            '5.5. We reserve the right to suspend or terminate accounts that violate these Terms, pose a risk to network security, or are used fraudulently.',
        },
      ],
    },
    {
      id: 'software',
      number: '06',
      title: 'Software, Plugins, Clients, and Modpacks',
      blocks: [
        {
          type: 'p',
          text:
            '6.1. On **Nexus Origins**, the gameplay experience is built with official Nexus Network plugins. The use of modpacks, content mods, or modified clients that alter gameplay in an unauthorized way is not part of this server\'s current proposal.',
        },
        {
          type: 'p',
          text:
            '6.2. It is strictly prohibited to use hacks, cheats, injectors, x-ray, auto-clickers, abusive macros, clients with unfair advantages, exploits, or any software that grants an improper benefit over other players.',
        },
        {
          type: 'p',
          text:
            '6.3. Purely cosmetic or quality-of-life mods (when expressly allowed by the administration) must not grant a competitive advantage. If in doubt, ask the staff before using them.',
        },
        {
          type: 'p',
          text:
            '6.4. Plugins, systems, scripts, APIs, integrations, and digital content developed by the Nexus Network / Vih\'s Studio are protected by intellectual property rights. Reverse engineering, copying, redistribution, or commercial exploitation without prior written authorization is prohibited.',
        },
        {
          type: 'p',
          text:
            '6.5. Attempts to compromise infrastructure (DDoS, abusive scanning, vulnerability exploitation, authentication bypass, etc.) will result in a ban and may be reported to the competent authorities.',
        },
      ],
    },
    {
      id: 'conduta',
      number: '07',
      title: 'Player Conduct',
      blocks: [
        {
          type: 'p',
          text:
            '7.1. All users must treat players, staff, and the community with respect.',
        },
        {
          type: 'p',
          text:
            '7.2. Hate speech, discrimination, harassment, bullying, threats, doxxing, sexual content involving minors, pornography, apology for crimes, and any illegal or offensive content are prohibited.',
        },
        {
          type: 'p',
          text:
            '7.3. Spam, flooding, unauthorized advertising, scams, phishing, and sharing malicious links are prohibited in-game, on Discord, and on other official channels.',
        },
        {
          type: 'p',
          text:
            '7.4. Using names, skins, builds, messages, or symbols that violate the law, third-party rights, or community guidelines is prohibited.',
        },
        {
          type: 'p',
          text:
            '7.5. Server-specific rules for each Nexus Network server (when published) supplement these Terms and must be observed.',
        },
      ],
    },
    {
      id: 'conteudo',
      number: '08',
      title: 'User Content and Intellectual Property',
      blocks: [
        {
          type: 'p',
          text:
            '8.1. You retain rights to original creations you produce on the server (builds, text, images, etc.), but you grant the Nexus Network / Vih\'s Studio a non-exclusive, royalty-free, worldwide license to display, record, promote, and use that content in official community materials (streams, social media, website, trailers), without any obligation of additional compensation.',
        },
        {
          type: 'p',
          text:
            '8.2. Trademarks, logos, visual identity, the names “Nexus”, “Nexus Origins”, “Nexus Network”, “Vih\'s Studio”, plugins, code, and official materials are owned by Vih\'s Studio or its licensors.',
        },
        {
          type: 'p',
          text:
            '8.3. Using Nexus Network marks in a way that suggests affiliation, partnership, or endorsement without express authorization is prohibited.',
        },
      ],
    },
    {
      id: 'punicoes',
      number: '09',
      title: 'Moderation and Penalties',
      blocks: [
        {
          type: 'p',
          text:
            '9.1. The moderation team reserves the right to apply disciplinary measures to users who violate these Terms, server rules, or community guidelines.',
        },
        {
          type: 'p',
          text:
            '9.2. Penalties may include warnings, mutes, kicks, removal of items/progress obtained improperly, temporary suspensions, or permanent bans, depending on severity and recidivism.',
        },
        {
          type: 'p',
          text:
            '9.3. Moderation decisions are, as a rule, final. Good-faith challenges may be submitted through the official channels indicated by the administration, with no guarantee of review or refund.',
        },
        {
          type: 'p',
          text:
            '9.4. The absence of an immediate penalty does not waive the right to apply sanctions later.',
        },
      ],
    },
    {
      id: 'doacoes',
      number: '10',
      title: 'Donations, VIP, and Financial Contributions',
      blocks: [
        {
          type: 'p',
          text:
            '10.1. Donations and financial contributions made to the Nexus Network / Vih\'s Studio (including via PIX or other available means) are, as a rule, **voluntary and non-refundable**, subject to applicable legal exceptions under the Brazilian Consumer Protection Code (Law No. 8,078/90) and other applicable rules.',
        },
        {
          type: 'p',
          text:
            '10.2. By making a donation or acquiring a benefit (such as VIP plans), the user acknowledges that:',
        },
        {
          type: 'ul',
          items: [
            'Spontaneous donations without consideration do not guarantee in-game advantages, except when expressly described in official campaigns or products.',
            'Funds raised are primarily intended to cover hosting, infrastructure, development, moderation, and improvements to the Nexus Network.',
            'VIP benefits or symbolic rewards, when offered, are virtual, non-transferable (unless expressly stated otherwise), and have no redeemable monetary value outside the platform.',
          ],
        },
        {
          type: 'p',
          text:
            '10.3. Under Brazilian tax law (Law No. 5,172/66 — National Tax Code), voluntary donations without consideration are not, by themselves, typical mercantile purchase-and-sale transactions of goods.',
        },
        {
          type: 'p',
          text:
            '10.4. Data provided during payment or donation will be processed in accordance with the LGPD (Law No. 13,709/18) for record-keeping, support, fraud prevention, and compliance with legal obligations.',
        },
        {
          type: 'p',
          text:
            '10.5. Benefits granted as thanks or as a digital product do not create an employment relationship, partnership, representation, or any other legal relationship beyond what is set out in these Terms.',
        },
        {
          type: 'p',
          text:
            '10.6. If a specific server or the Nexus Network is shut down, amounts already applied to operating costs will not be refunded. Active digital benefits may be terminated without a right to compensation, subject to non-waivable legal obligations.',
        },
        {
          type: 'p',
          text:
            '10.7. Improper chargeback attempts, payment fraud, or abuse of donation/VIP systems may result in a ban and pursuit of applicable remedies.',
        },
      ],
    },
    {
      id: 'disponibilidade',
      number: '11',
      title: 'Availability and Maintenance',
      blocks: [
        {
          type: 'p',
          text:
            '11.1. We strive to keep services stable, but we do not guarantee uninterrupted availability, freedom from errors, or compatibility with all devices and connections.',
        },
        {
          type: 'p',
          text:
            '11.2. Scheduled or emergency maintenance, restarts, rollbacks, partial progress loss, and interruptions caused by third-party failures (hosting, internet, Discord, payment gateways, etc.) may occur.',
        },
        {
          type: 'p',
          text:
            '11.3. We recommend that players not base critical expectations solely on the permanent continuity of any world, item, or feature.',
        },
      ],
    },
    {
      id: 'isencao',
      number: '12',
      title: 'Disclaimer and Limitation of Liability',
      blocks: [
        {
          type: 'p',
          text:
            '12.1. To the maximum extent permitted by Brazilian law, the Nexus Network and Vih\'s Studio are not liable for indirect damages, lost profits, loss of data, virtual items, playtime, or opportunities arising from use of or inability to use the services.',
        },
        {
          type: 'p',
          text:
            '12.2. We are not responsible for other players\' conduct, third-party content, external links, or partner platform services outside our direct control.',
        },
        {
          type: 'p',
          text:
            '12.3. Nothing in these Terms excludes consumer rights that cannot be waived by agreement under applicable law.',
        },
      ],
    },
    {
      id: 'privacidade',
      number: '13',
      title: 'Privacy Policy (LGPD)',
      blocks: [
        {
          type: 'p',
          text:
            'This section constitutes the Privacy Policy of the Nexus Network / Vih\'s Studio and describes how we process personal data in accordance with Brazil\'s General Data Protection Law (Law No. 13,709/18).',
        },
        { type: 'h', text: '13.1. Controller' },
        {
          type: 'p',
          text:
            'Personal data processing within the Nexus Network is carried out under the responsibility of Vih\'s Studio, through the official contact channels indicated in this document.',
        },
        { type: 'h', text: '13.2. Data we may collect' },
        {
          type: 'ul',
          items: [
            'Game identifiers (Minecraft nickname, UUID) and website account data.',
            'Contact data provided voluntarily (email, Discord ID/username).',
            'Technical connection and security data (IP address, access logs, timestamps, device/browser information, when applicable).',
            'Moderation records, support tickets, and interactions on official channels.',
            'Payment/donation data needed to process the transaction (handled, in part, by third-party payment processors).',
          ],
        },
        { type: 'h', text: '13.3. Purposes of processing' },
        {
          type: 'ul',
          items: [
            'Provide, operate, protect, and improve Nexus Network services.',
            'Authenticate users and prevent fraud, abuse, and security incidents.',
            'Enforce community rules and moderation decisions.',
            'Process donations, VIP benefits, and user support.',
            'Comply with legal obligations and respond to competent authorities when required.',
            'Communicate relevant service updates when necessary.',
          ],
        },
        { type: 'h', text: '13.4. Legal bases' },
        {
          type: 'p',
          text:
            'We process data based on performance of a contract/pre-contractual procedures, legitimate interest (community security and operations), compliance with a legal obligation, and/or consent, as applicable in each case.',
        },
        { type: 'h', text: '13.5. Sharing' },
        {
          type: 'p',
          text:
            'We do not sell personal data. We may share information with essential providers (hosting, controlled analytics, payment gateways, communication platforms) and with authorities when legally required. We require suppliers to process data appropriately for the contracted purpose.',
        },
        { type: 'h', text: '13.6. Cookies and similar technologies' },
        {
          type: 'p',
          text:
            'The website may use cookies and equivalent technologies for authentication, preferences, security, and usage analysis. You can manage cookies in your browser settings, understanding that certain features may be affected.',
        },
        { type: 'h', text: '13.7. Retention' },
        {
          type: 'p',
          text:
            'We retain data for as long as necessary for the described purposes, to regularly exercise rights, and to meet legal obligations. Security and moderation logs may be retained for periods consistent with preventing abuse and recidivism.',
        },
        { type: 'h', text: '13.8. Security' },
        {
          type: 'p',
          text:
            'We adopt reasonable technical and administrative measures to protect personal data. No system is absolutely secure; we encourage users to follow good account-protection practices.',
        },
        { type: 'h', text: '13.9. Data subject rights' },
        {
          type: 'p',
          text:
            'Under the LGPD, you may request confirmation of processing, access, correction, anonymization, portability (when applicable), deletion of unnecessary data, information about sharing, and withdrawal of consent. Requests may be made through official channels (Nexus Network Discord). We may request identity verification before fulfilling a request.',
        },
        { type: 'h', text: '13.10. Minors' },
        {
          type: 'p',
          text:
            'We do not intentionally collect data from children below the permitted minimum age without adequate legal bases. Guardians who identify an irregular registration should contact the administration for appropriate action.',
        },
      ],
    },
    {
      id: 'alteracoes',
      number: '14',
      title: 'Changes to These Terms',
      blocks: [
        {
          type: 'p',
          text:
            '14.1. We may update these Terms and the Privacy Policy periodically to reflect legal, technical, or operational changes to the Nexus Network.',
        },
        {
          type: 'p',
          text:
            '14.2. The current version will be published on this page, with the date of the last update indicated. Material changes may be announced through official channels.',
        },
        {
          type: 'p',
          text:
            '14.3. Continued use of the services after changes are published constitutes acceptance of the new version, except where the law requires specific consent.',
        },
        {
          type: 'note',
          text:
            '**Note:** These Terms were updated on 07/23/2026 to reflect the **Nexus Network** identity, the active **Nexus Origins** server (official Vih\'s Studio plugins), the multi-server scope of the website, and a strengthened Privacy Policy in light of the LGPD and other applicable Brazilian rules.',
        },
      ],
    },
    {
      id: 'lei',
      number: '15',
      title: 'Governing Law and Contact',
      blocks: [
        {
          type: 'p',
          text:
            '15.1. These Terms are governed by the laws of the Federative Republic of Brazil. The venue shall be the court of the consumer user\'s domicile, when the Consumer Protection Code applies, or another legally competent venue.',
        },
        {
          type: 'p',
          text:
            '15.2. If any clause is held invalid, the remaining clauses shall remain in full force and effect.',
        },
        {
          type: 'p',
          text:
            '15.3. Questions about these Terms, the Privacy Policy, or the exercise of data subject rights should preferably be directed to the official Nexus Network Discord.',
        },
      ],
    },
  ],
};
